import axios from 'axios';
import i18next from 'i18next';
import paths from './paths';
import { history } from './history';
import appConfig from './config';
import { store } from './store';
import { loginModule } from '../pages/LoginPage/LoginDucks';

const isDictionaryRequest = config =>
  Boolean(config && config.url && config.url.indexOf('/nedb-ddm/api/') !== -1);

const handleBaseUrlInterceptor = config => {
  if (config && config.url) {
    if (config.url.indexOf('api:services') !== -1) {
      const newConfig = {
        ...config,
        baseURL: appConfig.url.service,
        url: config.url.slice(12)
      };
      if (isDictionaryRequest(config)) {
        newConfig.headers['Cache-Control'] = 'no-cache';
      }
      return newConfig;
    }
    if (config.url.indexOf('api:fileStore') !== -1) {
      return {
        ...config,
        baseURL: appConfig.url.fileStore,
        url: config.url.slice(13)
      };
    }
  }
  return config;
};

const handleLanguageInterceptor = config => {
  if (config.url.includes('/api/public/notification-message/self/info/paging')) {
    return config;
  }
  let contentLang;
  switch (i18next.language) {
    case 'ru':
      contentLang = 'ru,ru-RU';
      break;
    case 'kk':
      contentLang = 'kk,kk-KZ';
      break;
    case 'en':
      contentLang = 'en,en-US';
      break;
    default:
      contentLang = 'en,en-US';
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      'Content-Language': contentLang
    }
  };
};

const configureAuth = config => {
  if (!config.headers.Authorization) {
    const newConfig = {
      headers: {},
      ...config
    };
    let accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      newConfig.headers.Authorization = `Bearer ${accessToken}`;
    }
    return newConfig;
  }
  return config;
};

const hasSession = () =>
  Boolean(
    store.getState()[loginModule].user ||
      localStorage.getItem('accessToken') ||
      localStorage.getItem('refreshToken')
  );

const unauthorizedResponse = async error => {
  const status = error.response && error.response.status;
  // справочники требуют токен: 403 от них — такая же невалидная сессия, как 401
  if (status === 401 || (status === 403 && isDictionaryRequest(error.config))) {
    // без сессии (публичные страницы: FAQ, очередь, реестр) не уводим на главную
    if (hasSession() && error.response.config.url.indexOf('login') === -1) {
      if (window.location.pathname !== paths.homePage) {
        history.push(paths.homePage);
      }
    }
  }
  return Promise.reject(error);
};

axios.defaults.baseURL = appConfig.url.base;
axios.interceptors.request.use(handleBaseUrlInterceptor, e => Promise.reject(e));
axios.interceptors.request.use(handleLanguageInterceptor, e => Promise.reject(e));
axios.interceptors.request.use(configureAuth, e => Promise.reject(e));
axios.interceptors.response.use(r => r, unauthorizedResponse);
